export default function setDetailChanges(prefix, changes) {
	return (dispatch) => {
		dispatch({
			type: 'SET_DETAIL_CHANGES',
			payload: {prefix, changes},
		});
	};
}